import styled from 'styled-components';
import { mediaQuery } from 'modules/utils';
import { Link } from 'react-router-dom';
import { HeaderLogo, HeaderLogoSm } from 'modules/ui/logo';
import { Submenu } from './submenu';

export const checkDisplay = (props: {
  $desktopOnly?: boolean;
  $mobileOnly?: boolean;
}) => {
  if (props.$desktopOnly) {
    return `
      display: none;
          
      ${mediaQuery('md')} {
        display: block;
      }
    `;
  }
  if (props.$mobileOnly) {
    return `
      display: block;
          
      ${mediaQuery('md')} {
        display: none;
      }
    `;
  }
  return ``;
};

export const StyledHeader = styled.header<{ visible: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 1.125rem 0;
  position: sticky;
  transition: top 0.4s ease-out;
  top: ${(props) => (props.visible ? 0 : '-7.5rem')};
  z-index: 10;
  background-color: ${({theme}) => theme.colors.primaryW};
`;

export const StyledHeaderContentContainer = styled.div`
  display: flex;
  padding: 0 2rem;
  width: 100%;
  max-width: 76rem;
  justify-content: center;
  align-items: center;
  flex: 1;
`;

export const StyledLeftContainer = styled.div`
  height: 2.6rem;
  display: flex;
  justify-content: flex-start;
  flex: 1 1 0px;
`;

export const StyledCentralContainer = styled.div`
  display: flex;
  justify-content: flex-end;

  & > * {
    margin: 0 0 0 1.7rem !important;
  }

  ${mediaQuery('md')} {
    flex: 1 1 0px;
    justify-content: center;
  }
`;

export const StyledRightContainer = styled.div`
  display: flex;
  justify-content: flex-end;

  & > * {
    margin: 0 0 0 1.7rem !important;
  }

  ${mediaQuery('md')} {
    flex: 1 1 0px;
  }
`;

export const StyledHeaderLogo = styled(HeaderLogo)`
  height: 2.625rem;
  color: ${({theme}) => theme.colors.primaryK10};
`;

export const StyledHeaderLogoSm = styled(HeaderLogoSm)`
  height: 2.625rem;
  color: ${({theme}) => theme.colors.primaryK10};
`;

export const StyledIconLink = styled(Link)<{
  $desktopOnly?: boolean;
  $mobileOnly?: boolean;
}>`
  ${(props) => checkDisplay(props)}
`;

export const StyledIconButton = styled.button<{
  $desktopOnly?: boolean;
  $mobileOnly?: boolean;
  $disabled?: boolean;
}>`
  background-color: transparent;
  border: 0;
  outline: 0;
  padding: 0;
  text-decoration: var(--text-underline);
  word-spacing: var(--word-spacing);
  
  cursor: ${(props) => (props.$disabled ? 'normal' : 'pointer')};

  ${(props) => checkDisplay(props)}
`;

export const StyledMobileSubmenu = styled(Submenu)`
  ${mediaQuery('md')} {
    display: none;
  }
`;

export const StyledDesktopSubmenu = styled(Submenu)`
  display: none;

  ${mediaQuery('md')} {
    display: flex;
  }
`;
